import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import check from "../assets/orders/check.png";
import { useTranslation } from "react-i18next";

const PaymentDone = () => {
    const { t, i18n } = useTranslation();
    const { language } = i18n;

    useEffect(() => {
        if (i18n.language === "ar") {
            document.body.setAttribute("dir", "rtl");
        } else {
            document.body.setAttribute("dir", "ltr");
        }
    }, [i18n.language]);

    return (
        <div className="loadingTab all_orders">
            <div className="bg-[#FCFBFA] px-20 max-lg:px-5 py-8">
                <Link to="/" className='flex items-center text-[#283D63] font-semibold'>


                    {
                        language == "en" ? <><LeftOutlined />
                            <p className='ml-3'>{t("Back_home")}</p>
                        </> : <>
                            <RightOutlined />
                            <p className='mr-3'>{t("Back_home")}</p>

                        </>
                    }

                </Link>

                <div className="mt-8">
                    <div className="flex items-center">
                        <h2 className="text-[#eaa182] font-semibold text-xl">{t("Payment_Processing")}</h2>
                    </div>
                </div>

            </div>
            <div className="chat-box px-20 max-lg:px-5 py-5 pb-20 mt-10">
                <img src={check} className="w-[60px] mx-auto mb-2" />
                <h2 className="text-[#14294F] font-semibold text-2xl text-center mt-8">{t("Payment_Processing_successfully")}</h2>
            </div>
        </div>
    );
};

export default PaymentDone;
